/* surisa-fig-fit.js — que el diagrama SVG quepa ENTERO en la pantalla.

   REGLA DE DISEÑO (decidida en QA, sep-2026): un diagrama de landing se ve
   completo de un vistazo. Nada de scroll horizontal dentro de la figura: si la
   pantalla es estrecha, el dibujo se reduce proporcionalmente. El texto encoge
   con él —va en unidades de viewBox— y eso es aceptable; lo que NO es
   aceptable es que las etiquetas se pisen o se corten.

   Encoger proporcionalmente NUNCA produce solapes: las distancias relativas no
   cambian. Los solapes que se veían venían de subir el `font-size` de los
   <text> por CSS, que agranda la etiqueta sin mover su ancla (docs/GOTCHAS.md
   § Frontend 10); esos parches están retirados y no deben volver.

   Lo único que sí hace falta corregir es el RECORTE: varios diagramas tienen
   alguna etiqueta anclada tan al borde que se sale del viewBox y, como el
   <svg> recorta por defecto, se pierde el final del texto («mandril ≈ 90 % Di»
   se quedaba en «mandril ≈ 90 %»). No depende del ancho: pasa igual en
   desktop. Este fichero amplía el viewBox lo justo para que quepan los
   <text> — el dibujo no se mueve, sólo se le da algo más de lienzo.

   NO TOCA: SVG sin viewBox o con menos de 2 <text> (iconos, chevrons, logos).
   Sin JS la página queda como estaba: es una mejora progresiva. */
(function () {
  var PAD = 2;          // margen en unidades de viewBox alrededor del texto
  var GROW_CAP = 1.25;  // tope de ampliación por eje; más que eso = rediseño

  var tracked = [];

  /* Caja de un <text> en coordenadas de viewBox, con las transformaciones de
     sus grupos YA aplicadas. `getBBox()` no vale: devuelve la caja en el
     espacio local del elemento, así que un <text> dentro de un
     <g transform="..."> da coordenadas que no se corresponden con dónde está
     realmente dibujado — y con ellas el viewBox se ampliaría hacia el lado
     equivocado. */
  function userBox(svg, el) {
    var m = svg.getScreenCTM();
    if (!m) return null;
    var inv = m.inverse();
    var r = el.getBoundingClientRect();
    if (!r.width) return null;
    var p = svg.createSVGPoint();
    p.x = r.left; p.y = r.top;
    var a = p.matrixTransform(inv);
    p.x = r.right; p.y = r.bottom;
    var b = p.matrixTransform(inv);
    return { x: Math.min(a.x, b.x), y: Math.min(a.y, b.y),
             width: Math.abs(b.x - a.x), height: Math.abs(b.y - a.y) };
  }

  // Parte SIEMPRE del viewBox original: la métrica del texto cambia cuando
  // entra la fuente web, así que la caja calculada con la fuente de sistema se
  // queda corta y hay que rehacer el cálculo, no acumularlo.
  function refit(it) {
    var x = it.orig[0], y = it.orig[1], w = it.orig[2], h = it.orig[3];
    var l = x, t = y, r = x + w, b = y + h, hit = false;
    Array.prototype.forEach.call(it.texts, function (el) {
      var bb = userBox(it.svg, el);
      if (!bb) return;
      if (l > bb.x - PAD) { l = bb.x - PAD; hit = true; }
      if (t > bb.y - PAD) { t = bb.y - PAD; hit = true; }
      if (r < bb.x + bb.width + PAD) { r = bb.x + bb.width + PAD; hit = true; }
      if (b < bb.y + bb.height + PAD) { b = bb.y + bb.height + PAD; hit = true; }
    });
    var next = hit && r - l <= w * GROW_CAP && b - t <= h * GROW_CAP
      ? l + ' ' + t + ' ' + (r - l) + ' ' + (b - t)
      : it.orig.join(' ');
    if (it.svg.getAttribute('viewBox') !== next) it.svg.setAttribute('viewBox', next);
  }

  function collect() {
    var svgs = document.querySelectorAll('.shopify-section svg[viewBox]');
    Array.prototype.forEach.call(svgs, function (svg) {
      if (svg.getAttribute('data-fig-fit') !== null) return;
      var texts = svg.querySelectorAll('text');
      if (texts.length < 2) return;

      var parts = (svg.getAttribute('viewBox') || '').trim().split(/\s+/);
      var box = [parseFloat(parts[0]), parseFloat(parts[1]),
                 parseFloat(parts[2]), parseFloat(parts[3])];
      if (!box[2] || !box[3]) return;

      svg.setAttribute('data-fig-fit', '');
      var it = { svg: svg, texts: texts, orig: box };
      refit(it);
      tracked.push(it);
    });
  }

  function run() {
    collect();
    tracked.forEach(refit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // La fuente web cambia el ancho de las etiquetas: la primera pasada mide con
  // la fuente de sistema y la caja se queda corta. Rehacer al cargarla.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(run);
  }
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(run, 150);
  });
})();
